import { Box, styled } from '@mui/material';

export const MainSectionBox = styled(Box)(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '12px',
  padding: '16px 20px 16px 20px',
  position: 'relative',
}));
